const Footer = () => {
    return (
        <footer className="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small ltr">
            <p className="text-muted mb-1 mb-md-0 tx-13">©  {new Date().getFullYear()} <a href="/">BestFeedIQ </a> Dashboard</p>
        </footer>
    );
}


export default Footer;